<template>
	<div id="app">
		<nav-bar v-show="$store.state.isNavBarShow"></nav-bar>
		<div id="contents">
			<div v-show="$store.state.isNavBarShow" class="navbar-space"></div>

			<router-view/>
		</div>

		<floating-menu v-show="$store.state.isFloatingMenuShow" :enableScrollTop="enableScrollTop"></floating-menu>

		<b-modal :active="isSelectModalActive" @close="$store.commit('closeSelectModal')">
			<select-modal
				:image="selectModal.image"
				:name="selectModal.name"
				:staffId="selectModal.staffId"
				:teamId="selectModal.teamId"
				:isTeam="selectModal.isTeam"
				>
			</select-modal>
		</b-modal>

		<b-modal :active="isInvitationModalActive" @close="$store.commit('closeInvitationModal')">
			<div class="invitation-modal text-center">
				<div class="sv-title">新メンバー招待</div>
				<div class="mt-15" style="font-size: 18px">QRコードを読み取って<br>新規登録画面へお進みください！</div>
				<img :src="require('@/assets/invitation_qrcode.png')" class="mt-20"/>
			</div>
		</b-modal>
	</div>
</template>

<style lang="scss">
// Buefy,bulma cssカスタマイズはここ
@import "@/scss/_vars.scss";

// ここで読み込む
@import "~bulma/sass/utilities/_all";
@import "~bulma";
@import "~buefy/src/scss/buefy";
@import "@/scss/main.scss";

$spaces: (0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50); // 0から50pxまでを用意
$sides: (top, bottom, left, right); // 方向性
@each $space in $spaces {
	@each $side in $sides {
		.m#{str-slice($side, 0, 1)}-#{$space} {
			margin-#{$side}: #{$space}px !important;
		}

		.p#{str-slice($side, 0, 1)}-#{$space} {
			padding-#{$side}: #{$space}px !important;
		}
	}
}

@font-face {
		font-family: 'M PLUS Rounded 1c';
		font-style: normal;
		font-weight: 400;
		font-display: swap;
	src: url('/fonts/MPLUSRounded1c-Regular.ttf') format("truetype");
}
@font-face {
		font-family: 'M PLUS Rounded 1c';
		font-style: normal;
		font-weight: 800;
		font-display: swap;
	src: url('/fonts/MPLUSRounded1c-ExtraBold.ttf') format("truetype");
}
html {
	&,body {
		height: 100%;
	}

	body {
		font-size: 15px !important;
		font-family: "M PLUS Rounded 1c";
		background: $bgColor;
		color: $color;
	}

	button.button {
		min-width: 143px;
		font-weight: $extraBold;
		font-size: 18px;
		font-family: inherit;
	}

	select,
	span.select {
		width: 100%;
	}

	input::placeholder {
		color: $gray;
	}

	.sv-textarea,
	.sv-input {
		border-radius: 1px;
		border: $commonBorder;
		padding: 15px;
		font-size: 18px !important;
		width: 100%;

		&.is-danger {
			border-color: $red;
		}

		&::placeholder {
			color: $gray;
		}
	}

	.sv-input {
		height: 50px;
	}

	.input-wrap {
		&:not(first-child) {
			margin-top: 20px;
		}

		.input-title {
			font-size: 18px;
			font-weight: $extraBold;
			margin-bottom: 7px;
			margin-left: $titleLeftMargin;
		}

		.name-horizontal {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.sv-input {
				width: 49%;
			}
		}

		.error-message {
			color: $red;
		}
	}

	.max-w-button {
		display: block;
		width: $buttonMaxW;
		margin: 0 auto;
	}

	.navbar-space {
		height: $headerH;
	}

	#contents {
		padding: 20px $basePadding 50px;
		background: $bgColor;
	}

	.horizontal-center {
		display: flex;
		align-items: center;
	}

	.horizontal-center-center {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.button-icon-right {
		img {
			margin-left: 10px;
		}
	}

	.field .label {
		font-size: 18px;
		font-weight: $extraBold;
		margin-left: $titleLeftMargin;
	}

	.require:after {
		content: ' ※';
	}

	.b-radio.radio:hover input[type=radio]:not(:disabled) + .check,
	.b-radio.radio input[type=radio] + .check,
	.b-radio.radio input[type=radio]:checked + .check {
		border-color: $borderColor;
	}

	.b-radio.radio input[type=radio] + .check:before {
		background-color: $skyBlue;
	}

	.b-radio.radio input[type=radio]:focus + .check {
		box-shadow: none !important;
	}

	.space {
		flex: 1;
	}

	.ellipsis {
		color: $gray;
	}

	.created {
		color: $gray;
		font-size: 12px;
	}

	.category {
		display: inline-block;
		font-size: 9px;
		padding: 7px;
	}

	.word-wrap {
		white-space: pre-wrap;
		word-wrap: break-word;
	}

	.sv-title {
		color: $titleColor;
		font-size: 18px;
		font-weight: $extraBold;
	}

	.button-center {
		display: block;
		margin: 0 auto;
	}

	hr {
		background: $borderColor;
		height: 1px;
		margin: 0;
	}

	.action-button {
		color: #775533;
		font-weight: $extraBold;
		cursor: pointer;
	}

	.bold18 {
		font-size: 18px;
		font-weight: $extraBold;
	}

	.text-center {
		text-align: center;
	}

	.common-coin-image {
		width: 70px;
		height: 74.15px
	}

	.highly-button {
		height: 80px;
		border-radius: 10px;
		font-size: 24px !important;
		width: 97%;
	}

	.kana {
		font-size: 12px;
		font-weight: $extraBold;
	}

	.tm { // title-margin
		margin-left: $titleLeftMargin;
	}

	.select:not(.is-multiple):not(.is-loading)::after {
		z-index: 0;
	}

	.section-title {
		font-size: 26px;
		font-weight: $extraBold;
		color: $brown;
		margin-left: $titleLeftMargin;
		margin-bottom: 15px;
	}

	.swiper-button-prev {
		background-image: url('./assets/slider_arrow_left.svg');
		left: 0;
	}

	.swiper-button-next {
		background-image: url('./assets/slider_arrow_right.svg');
		right: 0;
	}

	.swiper-button-prev, .swiper-button-next {
		width: 24px;
		height: 40px;
		margin-top: -24px;
		background-size: 24px 40px;
	}

	.organizer {
		color: $red;
	}

	.modal-background {
		background-color: rgba(10, 10, 10, 0.5);
	}

	.sv-tabs {
		justify-content: space-around;
		color: $brown;

		.sv-tab {
			cursor: pointer;

			hr.sv-tab-underline {
				background: $primary;
				height: 5px;
				width: 50px;
				margin: 5px auto 0;
				border-radius: 10px;
			}
		}
	}

	.invitation-modal {
		background: #fff;
		padding: 30px 0;

		.sv-title {
			font-size: 26px;
		}

		img {
			width: 180px;
			height: auto;
		}
	}

	.loginid-notice {
		font-weight: normal;
		font-size: 14px;
	}
}

@media screen and (min-width: $breakPoint) {
html {

	#app {
		background: $bgColor;
	}

	#contents {
		width: $pcW;
		margin-left: auto;
		margin-right: auto;
		padding-top: 50px;
		padding-left: $basePaddingPc;
		padding-right: $basePaddingPc;

		.screen-title-pc-wrap {
			display: block !important;
			
			.screen-title-pc {
				font-size: 26px;
				font-weight: bold;
				color: $brown;
				border-bottom: $brown 3px dotted;
				padding-bottom: 20px;
				margin-bottom: 30px;

				img {
					width: 32px;
					height: 32px;
				}
			}
		}
	}
}

}

</style>

<script>
import NavBar from '@/components/NavBar'
import FloatingMenu from '@/components/FloatingMenu'
import SelectModal from '@/components/SelectModal'
import { mapState } from 'vuex'

export default {
	name: 'App',
	components: {
		NavBar,
		FloatingMenu,
		SelectModal,
	},
	data () {
		return {
			NativeBridge: null,
			pageTitle: '',
			pageTitleIcon: 'default',
			isScreenTitleShow: true,
			enableScrollTop: true,
		}
	},
	created() {
		if (this.$utils.isApp()) {
			this.$store.commit('basic', {
				key: 'isNavBarShow',
				value: false,
			})
		} else {
			this.$store.commit('basic', {
				key: 'isNavBarShow',
				value: true,
			})
			this.$store.commit('basic', {
				key: 'isFloatingMenuShow',
				value: true,
			})
		}

		let self = this;
		this.NativeBridge = {
			send: function(methodName, args) {
				self.$utils.log('send called!!!!!');
				if (self.$utils.isIOS()) {
					self.$utils.log('ios access');
					window.webkit.messageHandlers[methodName].postMessage(args);
				} else if (self.$utils.isAndroid()) {
					self.$utils.log('android access');
					window.MyApp[methodName](args);
				} else {
					self.$utils.log('browser access.');
				}
			},
		};
	},
	mounted() {
		//setTimeout(function() {
		//	window.scrollBy(0, 3000);
		//},1000);
		this.$store.commit('updateInnerWitdh', window.innerWidth);
		let self = this;
		window.addEventListener('resize', function () {
			self.$store.commit('updateInnerWitdh', window.innerWidth);
		});
	},
	watch: {
		'$route' (to, from) {
			//this.$utils.log('App.vue watch');
			//this.$utils.log('to');
			//this.$utils.log(to.name);
			//this.$utils.log('from');
			//this.$utils.log(from.name);

			this.NativeBridge.send('sendMessage', 'test message.');// アプリ連携用

			if (to.meta.title) {
				document.getElementsByTagName('title')[0].innerText = to.meta.title;
				this.pageTitle = to.meta.title;
			}

			if (to.meta.icon) {
				this.pageTitleIcon = to.meta.icon;
			}

			if (to.name === 'top' || to.name === 'login' || to.name === 'staff-new') {
				this.isScreenTitleShow = false;
			}

			if (to.name === 'team-talk' || to.name === 'app-team-new' || to.name === 'team-talk-view') {
				this.enableScrollTop = false;
			}

			if (to.name === 'news') {
				if (from.name !== 'news-view') {
					this.$store.commit('basic', {
						key: 'isCurrentNewsStateStored',
						value: false,
					});
					this.$store.commit('basic', {
						key: 'currentNewsTabIndex',
						value: 0,
					});
					this.$store.commit('basic', {
						key: 'currentNewsTabScrollLeft',
						value: 0,
					});
					this.$store.commit('basic', {
						key: 'currentNews',
						value: null,
					});
				}
			}

			if (to.name === 'coin-present') {
				if (from.name !== 'staff' && from.name !== 'team') {
					this.$store.commit('basic', {
						key: 'isCurrentCoinPresentStateStored',
						value: false,
					});
					this.$store.commit('basic', {
						key: 'coinPresent',
						value: null,
					});
				}
			}
		}
	},
	computed: {
		...mapState([
			'selectModal',
			'isSelectModalActive',
			'isInvitationModalActive',
		]),
	},
	methods: {
		pageLoaded: function() {
			// アプリ側との連携用
		},
	}
}
</script>
